import { Route, Routes } from 'react-router-dom';
import DeployerPage from './DeployerPage';
import DeployWorkspace from './DeployWorkspace';
import MainDeployerLayout from './MainDeployerLayout';

function DeployerRoutePage() {

    return (
        
        <Routes>
            <Route path="/" element={<MainDeployerLayout />} >
                <Route path="/" element={<DeployerPage />} />
                <Route path="/workspace" element={<DeployWorkspace />} />
            </Route>
        </Routes>
        
    )
}

export default DeployerRoutePage